<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-multiSelect
    #multi
    [class.bf-multiselect-readonly]="props.readonly"
    [options]="
      checkIfObservable(props.options) ? (props.options | async) : props.options
    "
    [optionLabel]="props.labelProp"
    selectedItemsLabel="{0} items selected"
    [maxSelectedLabels]="1"
    [placeholder]="props.placeholder"
    [filterPlaceHolder]="props.filterPlaceHolder"
    [appendTo]="props.appendTo ?? 'body'"
    [readonly]="props.readonly"
    [showClear]="props.showClear"
    [group]="true"
    scrollHeight="250px"
    (onChange)="props.change && props.change(field, $event)"
    [formControl]="formControl"
    (keydown)="props.keydown ?? onKeyDown($event)"
  >
    <ng-template let-group pTemplate="group">
      <div class="b-f-multiselectgrouped-grouplabel">
        <span>{{ group.label }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="filter">
      <p-checkbox
        [binary]="true"
        [ngModel]="multi.allSelected()"
        (onChange)="multi.onToggleAll($event)"
        [disabled]="disabled"
        [ariaLabel]="toggleAllAriaLabel"
      ></p-checkbox>

      <div class="p-multiselect-filter-container">
        <basin-searchbox
          class="bf-multiselectgrouped-filter-searchbox"
          [searchString]="multi.filterValue"
          (searchStringChange)="
            multi.onFilterInputChange({ target: { value: $event } })
          "
          [placeholder]="props.filterPlaceholder ?? 'Search...'"
        ></basin-searchbox>
      </div>

      <button
        type="button"
        pButton
        icon="symbol-close"
        class="p-multiselect-close"
        (click)="multi.close($event)"
        [attr.aria-label]="'Close'"
      ></button>
    </ng-template>
  </p-multiSelect>
</span>
